import React from 'react';
import { Svg } from '../../index'
import styles from '../AccountingBookLabel/accountingBookLabel.module.scss'

const AccountingBookAddLabel = (props) => {
  return (
    <div className={styles.addCard} onClick={props.clicked}>
      <span className={styles.addIcon}>
        <Svg icon='add' size='24' className='white' />
      </span>
      <span className={styles.addText}>新增帳本</span>
    </div>
  )
};

export default AccountingBookAddLabel;
